<template>
    <div class="bottom-banner1_ext" />
</template>
<script>
export default {};
</script>
